import { Route } from '@angular/router';
import { AuthGuard, AntiAuthGuard } from '@frontend/shared';
import { SETTINGS_ROUTES } from '@clientwire/settings';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () => import('@frontend/shared').then((m) => m.LoginComponent),
    canActivate: [AntiAuthGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@frontend/shared').then((m) => m.ResetPasswordComponent),
    canActivate: [AntiAuthGuard],
  },
  {
    path: 'set-password',
    loadComponent: () => import('@frontend/shared').then((m) => m.SetPasswordComponent),
  },
  {
    path: 'settings',
    children: SETTINGS_ROUTES,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    loadComponent: () => import('@frontend/shared').then((m) => m.DashboardComponent),
    canActivate: [AuthGuard],
  },
];
